export default __webpack_public_path__ + "static/DougArmstrong-db74b29571ddf6c3eedb341cb3a7af47.jpg";